import React from 'react';
import AddOnPreview from './AddOnPreview'

export default class CustomOption extends React.Component {
  render() {
    const { innerRef, innerProps, value, label, data } = this.props

    return (
      <div
        {...innerProps}
        ref={innerRef}
      >
        <AddOnPreview data={data} />
      </div>
    )
  }
}
